module.exports = __webpack_public_path__ + "static/media/full_logo_white_outline.74341bf5.png";